import axios from "axios";

const configAuth = () => {
  return `Bearer ${localStorage.getItem("token")}`;
};

const get = (url, auth = true) => {
  return axios.get(process.env.VUE_APP_API_URL + url, {
    headers: {
      Authorization: auth ? configAuth() : "",
      // "Content-Type": contentType === null ? "application/json" : contentType,
    },
  });
};

const post = (url, data, auth = true) => {
  return axios.post(process.env.VUE_APP_API_URL + url, data, {
    headers: {
      Authorization: auth ? configAuth() : "",
      // "Content-Type": contentType === null ? "application/json" : contentType,
    },
  });
};
const call = {
  get,
  post,
};

export default call;
